
import React from 'react';
import './Sidebar.css';
import { useAppState, TopPage } from '../../context/AppStateContext';
import SilverIcon from '../shared/SilverIcon';

interface NavItem {
  id: TopPage;
  label: string;
  icon: React.ComponentProps<typeof SilverIcon>['name'];
}

const NAV_ITEMS: NavItem[] = [
  { id: 'home', label: 'Home', icon: 'home' },
  { id: 'business', label: 'Business', icon: 'business' },
  { id: 'studio', label: 'Studio', icon: 'studio' },
  { id: 'ops', label: 'Ops', icon: 'ops' },
];

interface Props {
  collapsed: boolean;
}

export default function Sidebar({ collapsed }: Props) {
  const { appState, setAppState } = useAppState();

  const navigate = (page: TopPage) => {
    setAppState(s => ({ ...s, currentPage: page }));
  };

  return (
    <aside className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}`}>
      <nav className="sidebar__nav">
        <div className="sidebar__section">
          {NAV_ITEMS.map(item => (
            <SidebarItem
              key={item.id}
              item={item}
              active={appState.currentPage === item.id}
              collapsed={collapsed}
              onClick={() => navigate(item.id)}
            />
          ))}
        </div>
      </nav>
      <div className="sidebar__bottom">
        <button
          className={`sidebar__item${appState.currentPage === 'home' ? '' : ''}`}
          title={collapsed ? 'Settings' : undefined}
          onClick={() => {/* handled via avatar menu */}}
          style={{ opacity: .5 }}
        >
          <SilverIcon name="settings" size={18} />
          {!collapsed && <span className="sidebar__item-label">Settings</span>}
        </button>
      </div>
    </aside>
  );
}

interface SidebarItemProps {
  item: NavItem;
  active: boolean;
  collapsed: boolean;
  onClick: () => void;
}

function SidebarItem({ item, active, collapsed, onClick }: SidebarItemProps) {
  return (
    <button
      className={`sidebar__item${active ? ' sidebar__item--active' : ''}`}
      onClick={onClick}
      title={collapsed ? item.label : undefined}
    >
      <span className="sidebar__item-icon">
        <SilverIcon name={item.icon} size={18} />
      </span>
      {!collapsed && <span className="sidebar__item-label">{item.label}</span>}
    </button>
  );
}
